import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from '../ui/FadeIn';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const isFor = ['Mujeres de 45 años o más que sufren de inflamación abdominal persistente.', 'Latinas que no quieren renunciar al sabor de su comida pero necesitan salud.', 'Mujeres ocupadas que necesitan una solución de nutrición rápida y portátil.', 'Personas que buscan un enfoque natural y espiritual para la menopausia.'];
  const notFor = ["Quienes buscan una 'pastilla mágica' sin cambiar ni un solo hábito.", 'Personas que no están dispuestas a invertir 15 minutos al día en su nutrición.', 'Mujeres que no creen en el poder de la suplementación de alta calidad.'];
  return <section className="bg-white py-24 px-6" data-id="element-13">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-14">
        <div className="bg-teal/5 p-10 rounded-sm border-t-4 border-teal" data-id="element-15">
          <FadeIn data-id="element-16">
            <h3 className="text-2xl font-serif text-charcoal mb-8" data-id="element-17">
              Este protocolo ES para ti si:
            </h3>
          </FadeIn>
          <StaggerContainer className="space-y-6" data-id="element-18">
            {isFor.map((item, idx) => <StaggerItem key={idx} className="flex gap-4 items-start" data-id="element-19">
                <div className="bg-teal/20 p-1 rounded-full text-teal flex-shrink-0 mt-1" data-id="element-20">
                  <Check className="w-4 h-4" data-id="element-21" />
                </div>
                <p className="text-charcoal/80" data-id="element-22">{item}</p>
              </StaggerItem>)}
          </StaggerContainer>
        </div>

        <div className="bg-red-50 p-10 rounded-sm border-t-4 border-red-300" data-id="element-23">
          <FadeIn data-id="element-24">
            <h3 className="text-2xl font-serif text-charcoal mb-8" data-id="element-25">
              Este protocolo NO ES para ti si:
            </h3>
          </FadeIn>
          <StaggerContainer className="space-y-6" data-id="element-26">
            {notFor.map((item, idx) => <StaggerItem key={idx} className="flex gap-4 items-start" data-id="element-27">
                <div className="bg-red-200 p-1 rounded-full text-red-600 flex-shrink-0 mt-1" data-id="element-28">
                  <X className="w-4 h-4" data-id="element-29" />
                </div>
                <p className="text-charcoal/80" data-id="element-30">{item}</p>
              </StaggerItem>)}
          </StaggerContainer>
        </div>
      </div>
    </section>;
}